// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","outline":"Button_outline__monpX","toast":"Button_toast__LTdbq","block":"Button_block__UdBMb"};